import { Link } from 'react-router-dom';

// Image
import aboutImg from '../../assets/images/about/ab.png';

const About = () => {

    return (
        <div className="about__area about__area_one p-relative pt---10 pb---120">
            <div className="container">                        
                <div className="row">
                    <div className="col-lg-6">
                        <div className="about__image">
                            <img src={aboutImg} alt="About" />
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="about__content">
                            <h2 className="about__title wow animate__fadeInUp" data-wow-duration="0.3s">Welcome to <br/> <em>MindMetric Aptitude</em></h2>
                            <p className="about__title wow animate__fadeInUp" data-wow-duration="0.5s">Discover Your True Potential. Every individual possesses a unique set of cognitive abilities and problem-solving skills.<br/> MindMetric Aptitude helps identify and quantify your strengths through scientifically designed assessments.</p>
                            <p className="about__paragraph2 wow animate__fadeInUp" data-wow-duration="0.7s"> Have questions?  <Link to="/contact"> Get Support </Link></p>
                            <p className="wow animate__fadeInUp" data-wow-duration="0.9s">Our Aptitude Assessment is a scientifically designed evaluation system that explores multiple dimensions of human potential.<br/> Instead of a single score, we measure quantitative reasoning, logical deduction, verbal ability, spatial awareness, and data interpretation skills.</p>
                            <ul>
                                <li><Link to="/about" className="more-about wow animate__fadeInUp" data-wow-duration="1.2s"> Learn More <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-arrow-right"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg></Link></li>
                                <li className="last-li wow animate__fadeInUp" data-wow-duration="1.3s">
                                    <em>Get Support</em>
                                    <a href="mailto:support@mindmetric.com">support@mindmetric.com</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default About;